import WhiteBoard from './components/WhiteBoard'
import { useRef } from 'react'

function App() {
  // const search = window.location.search
  // const params = new URLSearchParams(search)
  // const isLeader = params.get('isLeader')

  const search = window.location.search
  const params = new URLSearchParams(search)
  const boardId = params.get('boardId')
  const shard = params.get('shard')
  const token = params.get('token')
  const isLeader = params.get('isLeader') === 'true'

  const wsUrl = `wss://${shard}.sigma13.yjs.klassmate.io`

  const whiteboardRef = useRef(null)
  const uploadImage = () => {
    return {
      src: 'board-images/20087935-da6f-4492-9f91-80836b76e3ac/5f903664-9a6b-4ce6-a942-4125d7fbdb89.png',
      w: 300,
      h: 300,
    }
  }

  return (
    <div className='App' draggable={false}>
      {/* <div
        className='w-[50px] h-[50px] bg-red-500'
        onClick={() =>
          test({
            uri: 'documents/abd3c69b-d180-11ef-b784-0a05c535cc9b/5275d3ef-1d59-4039-995f-c6d4f5a1aefb/image37.png',
            w: 1960,
            h: 1080,
          })
        }
      >
        testtest
      </div> */}
      <WhiteBoard
        ref={whiteboardRef}
        boardId={boardId}
        userId={'e6e55eea-bf7c-11ef-b784-0a05c535cc9b'}
        token={
          'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJhNTZkMDBjNy0xODJiLTRiMGItOTk1OS1kMzMyODkwOGU2MjEiLCJyb2xlIjoiVEVBQ0hFUiIsImJvYXJkSWQiOiJjYWEzZjkwNi0yOTNhLTQ3NmQtYWIxMS0zZWEwMTJjOTQxYmEiLCJpYXQiOjE3NTkzOTA3ODIsImV4cCI6MTc1OTQxMjM4Mn0.dy5iLsxxsdqV1vKUcNnxeTMonuIwhq8s4IN0ErSVj8nznhBPCSlBWbLC6jK3P7H0w_UrhMAe42dqi8QzN2EGGIs-oWGPBeG8e6BdZ6P-6qwzTzRP2ZY7uPUzXfR6off4aCiIrRBBjAmnkI_rCTMRGEXEruXWup9G6A1RxQASYaLyzai3m4cJtWSyckbezp3PJ1B7PnS4A4hjzNLiMpEq-Hip_Rn-Uf7VK2g8yHKVz5R8Z5i-NhV0cxZddvlubt3lDh8pHMT1Xw5o9UVlQnUxhNU-u_Fn7H2rA-HjnpBDaE0Uawy9qkFVCU6z5LBj5uqe-7YUk25egbHtieZgLZz5qQ'
        }
        wsUrl={wsUrl}
        isStudent={true} // 학생: toolbar-이미지 자료실 접근 불가능
        isWritable={true} // 집중 모드: 학생은 화이트보드 조작 불가능, toobar 및 bottomPanel 제어 불가능
        /* ***********************
        // [ 동시편집 스코프 동작 방식 ]
        * ***********************/
        // -> 집중모드와 개별모드에 관계없이 선생님 웹과 전자칠판, 'TEACHER'끼리만 동기화
        // -> 개별모드에서 학생과 선생님 간의 스코프 연결 X
        // 2024.03 이우주
        isLeader={true} // TEACHER만 리더
        isListener={true} // 집중모드: 선생님, 학생 모두 listener | 개별모드: 'TEACHER'끼리만 동기화
        isiOSAfterImageStyleActive={true}
        // 개발 모드
        isDev={true}
        uploadImage={uploadImage}
        openImageModal={uploadImage}
      />
    </div>
  )
}

export default App
